import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useNavigate, useOutletContext } from "react-router-dom";
import BottomFullWidthButtonContainer from "../../../../components/shared/BottomFullWidthButtonContainer";
import { useRequest } from "../../../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../../../api/APIs";
import { useEffect } from "react";
import SejamStatusImage from "../../../../assets/images/sejam-status.png";
import { ReactComponent as OutlinedStatusIcon } from "../../../../assets/icons/outline-status-Info.svg";
import { ReactComponent as CheckBoxIcon } from "../../../../assets/icons/check-box-colored.svg";
import moment from "moment-jalaali";
import AuthStatusBox from "../../../../components/auth/AuthStatusBox";
import CustomRectangularSkeleton from "../../../../components/shared/CustomRectangularSkeleton";

function ProfileSettingSejamStatusPage() {
  const navigate = useNavigate();
  const { isUpdated, setIsUpdated } = useOutletContext();

  const {
    loading: getstatusLoading,
    result,
    apiCall: getSejamStatus,
  } = useRequest(BalootUserV2APIs.getSejamStatus, true);

  const { loading: checkStatusLoading, apiCall: sejamStatusCheckPut } =
    useRequest(BalootUserV2APIs.sejamStatusCheckPut);

  const onUpdateClick = () => {
    sejamStatusCheckPut({
      onSuccess: (response) => {
        if (response.status === "OTP_SENT") {
          navigate("../otp");
        } else {
          setIsUpdated(true);
        }
      },
    });
  };

  useEffect(() => {
    getSejamStatus({ data: { updated: isUpdated } });
  }, [isUpdated]);

  const getStatusLabel = (status) => {
    switch (status) {
      case "NOT_AVAILABLE":
        return "ثبت‌نام نشده";
      case "INCOMPLETE":
      case "INPROGRESS":
        return "نقص اطلاعات";
      case "REGISTERED":
        return "احراز هویت نشده";
      case "AUTHENTICATED":
        return "تایید شده";
      default:
        return "نامشخص";
    }
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            سجام
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb:
            result && isUpdated && result.status === "INCOMPLETE"
              ? "112px"
              : "24px",
        }}
      >
        {getstatusLoading ? (
          <>
            <CustomRectangularSkeleton height={80} />
            <CustomRectangularSkeleton sx={{ mt: 3 }} height={100} />
          </>
        ) : (
          result && (
            <Box
              sx={{
                flex: 1,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                pb: 2,
              }}
            >
              <Box
                sx={{
                  boxShadow: (theme) => theme.shadows[2],
                  width: "100%",
                  minHeight: 108,
                  borderRadius: "8px",
                  p: "24px",
                  display: "flex",
                  mb: "24px",
                }}
              >
                <img
                  src={SejamStatusImage}
                  width={60}
                  height={60}
                  alt="sejam status"
                />
                <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle1" color="secondary.main">
                      وضعیت سجام
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      color={
                        result.status === "AUTHENTICATED"
                          ? "primary.main"
                          : "red.main"
                      }
                    >
                      {getStatusLabel(result.status)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      borderLeft: (theme) =>
                        `1px solid ${theme.palette.grey[6]}`,
                    }}
                  >
                    <Typography variant="subtitle1" color="secondary.main">
                      آخرین به‌روزرسانی
                    </Typography>
                    <Typography variant="subtitle1" color={"grey.2"}>
                      {moment(result.lastUpdated).format("HH:mm jYYYY/jMM/jDD")}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <AuthStatusBox
                title={result.message?.title}
                body={result.message?.body}
                buttonTitle={"به‌روزرسانی وضعیت"}
                buttonAction={!isUpdated && onUpdateClick}
                icon={
                  isUpdated
                    ? result.status === "AUTHENTICATED"
                      ? CheckBoxIcon
                      : OutlinedStatusIcon
                    : OutlinedStatusIcon
                }
                loading={checkStatusLoading}
              />
            </Box>
          )
        )}

        {result && isUpdated && result.status === "INCOMPLETE" && (
          <BottomFullWidthButtonContainer>
            <Button
              onClick={() => {
                window.open(result.url);
              }}
              sx={{
                color: "common.white",
                typography: "h3",
              }}
              variant="contained"
              fullWidth
            >
              تکمیل حساب سجام
            </Button>
          </BottomFullWidthButtonContainer>
        )}
      </PageContentContainer>
    </>
  );
}

export default ProfileSettingSejamStatusPage;
